
<template>
  <div>
    <div class="mb20">
      <el-button type="primary" @click="addUser" size='small' v-show="$ButtonShow('YHP_ADD_02')">指派项目管理人员</el-button>
    </div>
    <el-table
      class="global-table" stripe
      :data="projectUserList"
      v-loading="loading">
      <el-table-column label="管理人员角色" prop="roleName" minWidth="120px" fixed="left"></el-table-column>
      <el-table-column label="姓名" prop="userName" minWidth="120px"></el-table-column>
      <el-table-column label="操作" minWidth="120px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="deleteProjectUser(row)" v-show="$ButtonShow('YHP_DEL_01')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="指派项目管理人员" :visible.sync="showAddUser" width="400px" :before-close="beforeCloseAddUser" :close-on-click-modal='false'>
      <el-form ref="addUserInfo" :model="addUserInfo"  :rules="addUserInfoRules" label-width="120px">
        <el-form-item label="选择角色" prop="role">
          <el-select size="small" v-model="addUserInfo.role" filterable clearable placeholder="请选择角色" @change="roleChange">
            <el-option v-for="(item,index) in roleList" :label="item.roleName" :value="item.roleId" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择人员" prop="userIdList">
          <el-select size="small" v-model="addUserInfo.userIdList" multiple filterable clearable placeholder="请选择人员">
            <el-option v-for="(item,index) in userList" :label="item.userName" v-model="item.userId" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="commitAddUser()" size='small'>确定</el-button>
          <el-button @click="cancelAddUser()" size='small'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'List',
  components: {
  },
  data () {
    return {
      loading: false,
      showAddUser: false,
      roleList: [],
      projectUserList: [],
      addUserInfo: {
        role: '',
        userIdList: []
      },
      addUserInfoRules: {
        role: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        userIdList: [{ required: true, message: '请选择人员', trigger: 'blur' }]
      },
      userList: []
    }
  },
  computed: {
  },
  created () {
    this.getProjectUserList()
  },
  methods: {
    // 获取项目人员列表
    getProjectUserList () {
      this.loading = true
      this.$axios.get(this.$apis.project.selectYhProjectUserByList, {
        projectId: this.$route.query.projectId
      }).then((res) => {
        this.projectUserList = res || []
        this.loading = false
      })
    },
    // 获取人员角色列表
    getRoleList () {
      this.$axios.get(this.$apis.system.getRoleList, {}).then((res) => {
        this.roleList = res
      })
    },
    // 获取用户列表
    getUserList (role) {
      this.userList = []
      this.$axios.get(this.$apis.system.getRoleUserList, {
        roleId: role
      }).then((res) => {
        this.userList = this.removeArrayTwo(res, this.projectUserList)
      })
    },
    // 从列表清除已在项目的数据
    removeArrayTwo (userList, innerList) {
      const arr = []
      userList.forEach(item => {
        if (innerList.findIndex(i => i.userId === item.userId) < 0) {
          arr.push(item)
        }
      })
      return arr
    },
    // 添加项目人员时角色切换重新获取相应用户列表
    roleChange () {
      this.addUserInfo.userIdList = []
      this.userList = []
      if (this.addUserInfo.role) {
        this.getUserList(this.addUserInfo.role)
      }
    },
    // 显示
    addUser () {
      this.getRoleList()
      this.showAddUser = true
    },
    // 添加项目管理人员
    commitAddUser () {
      this.$refs.addUserInfo.validate(valid => {
        if (valid) {
          this.$axios.post(this.$apis.project.insertYhProjectByProjectId, {
            projectId: this.$route.query.projectId,
            userIdList: this.addUserInfo.userIdList
          }).then(() => {
            this.$message.success('新增成功')
            this.getProjectUserList()
            this.cancelAddUser()
          })
        }
      })
    },
    beforeCloseAddUser (done) {
      this.cancelAddUser()
      done()
    },
    // 取消添加项目管理人员
    cancelAddUser () {
      this.$refs.addUserInfo.resetFields()
      this.$refs.addUserInfo.clearValidate()
      this.showAddUser = false
    },
    // 删除项目人员
    deleteProjectUser (row) {
      this.$confirm('确认删除' + row.userName + '吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$axios.post(this.$apis.project.deleteDataYhProjectUser, {
          userId: row.userId,
          projectId: this.$route.query.projectId
        }).then(() => {
          this.$message.success('删除成功')
          this.getProjectUserList()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
